import {
  cvSearchSyncStatusTranslation,
  CvSearchSyncStatusTranslation,
} from '@/assets/locales/layouts/cvSearchSyncStatus/cvSearchSyncStatus.translation.en.ts';
import {
  footerTranslation,
  FooterTranslation,
} from '@/assets/locales/layouts/footer/footer.translation.en.ts';

export type LayoutsTranslation = {
  cvSearchSyncStatus: CvSearchSyncStatusTranslation;
  environmentBanner: {
    dev: {
      description: string;
      title: string;
    };
    preview: {
      description: string;
      title: string;
    };
  };
  footer: FooterTranslation;
  logout: {
    tooltip: string;
  };
};

export const layoutsTranslation: LayoutsTranslation = {
  cvSearchSyncStatus: cvSearchSyncStatusTranslation,
  environmentBanner: {
    dev: {
      description: 'Development environment, which may be unstable.',
      title: 'Development environment',
    },
    preview: {
      description:
        'Pre-production environment, as close to production as possible, with possible fixes or final tests of new features.',
      title: 'Pre-production environment',
    },
  },
  footer: footerTranslation,
  logout: {
    tooltip: 'Logout',
  },
};
